<template>
  <section class="apis-index-container">
    <base-header v-bind="headers"
      v-on:handleCreate="handleHeaderCreate"
      v-on:handleDelete="handleHeaderDelete"
    />
    <search-header
      class="search-header"
      v-bind="searchHeader"
      :params="list.params"
      @handleSearch="handleSearch"
    ></search-header>
    <base-table
      v-bind="list"
      v-on:handleSelectionChange="handleSelectionChange"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
      v-on:handleDelete="handleTableDelete"
    ></base-table>
    <form-dialog
      ref="addDialog"
      :loading="addFormLoading"
      :form="addForm"
      :rules="addRules"
      :formItems="addFormItems"
      v-on:handleConfirm="handleConfirmAdd"
    ></form-dialog>
  </section>
</template>

<script>
import baseHeader from '@/components/mixins/baseHeader'
import searchHeader from '@/components/mixins/searchHeader'
import baseTable from '@/components/mixins/baseTable'
import formDialog from '@/components/mixins/formDialog'
import { mapState, mapActions } from 'vuex'

const columns = [
  {
    prop: 'apiName',
    label: '接口名称',
    scopeType: 'link',
    href: '/system/menus/apis/detail'
  },
  {
    prop: 'apiUrl',
    label: '接口地址'
  },
  {
    prop: 'requestMethod',
    label: '请求方式',
    formatter: (row, column, cellValue, index) => {
      const options = [
        {
          label: 'GET',
          value: 1
        },
        {
          label: 'POST',
          value: 2
        },
        {
          label: 'DELETE',
          value: 3
        },
        {
          label: 'UPDATE',
          value: 4
        },
        {
          label: 'PUT',
          value: 5
        }
      ]
      const opt = options.find(d => d.value === cellValue)
      return opt ? opt.label : ''
    }
  },
  {
    prop: 'useScene',
    label: '使用场景'
  }
]

export default {
  name: 'menusApisIndex',
  mixins: [baseHeader, searchHeader, baseTable, formDialog],
  data () {
    return {
      searchHeader: {
        searchItems: [
          {
            type: 'input',
            value: 'apiName',
            placeholder: 'API名称'
          },
          {
            type: 'searchInput',
            value: 'apiUrl',
            placeholder: 'API地址'
          }
        ]
      },
      list: {
        columns,
        api: 'fetchApisList',
        params: {
          apiName: '',
          apiUrl: ''
        },
        handleColumn: [
          {
            type: 'Delete',
            name: '删除',
            icon: 'delete',
            disabled: !this._checkPermission('/admin/apis', 'DELETE')
          }
        ],
        handleColumnProp: {
          label: '操作',
          align: 'left'
        }
      },
      headers: {
        buttons: [
          {
            type: 'Create',
            text: '新建',
            icon: 'xinjian',
            disabled: !this._checkPermission('/admin/apis', 'POST')
          },
          {
            type: 'Delete',
            text: '删除',
            icon: 'delete',
            disabled: !this._checkPermission('/admin/apis', 'DELETE')
          }
        ],
        title: '',
        showAlertIcon: true,
        content: '操作说明'
      },
      addFormLoading: false,
      addForm: {
        requestMethod: 1,
        apiName: '',
        apiUrl: '',
        useScene: ''
      },
      addRules: {
        requestMethod: [
          this.$rules.required()
        ],
        apiName: [
          this.$rules.required()
        ],
        apiUrl: [
          this.$rules.required(),
          {
            validator: (rule, value, callback) => {
              if (value) {
                var params = {
                  url: value,
                  requestMethod: this.addForm.requestMethod
                }
                this.$request.fetchApisUnique(params).then(res => {
                  if (res.code === 200 && res.data) {
                    callback()
                  } else {
                    callback(new Error('API地址不能重复'))
                  }
                })
              }
            },
            trigger: 'blur'
          }
        ]
      },
      addFormItems: [
        {
          prop: 'apiName',
          label: '接口名称',
          placeholder: '请输入接口名称',
          maxLength: 50
        },
        {
          prop: 'apiUrl',
          label: '接口地址',
          placeholder: '请输入接口地址',
          maxLength: 120
        },
        {
          type: 'select',
          prop: 'requestMethod',
          label: '请求方式',
          placeholder: '请选择',
          options: [
            {
              label: 'GET',
              value: 1
            },
            {
              label: 'POST',
              value: 2
            },
            {
              label: 'DELETE',
              value: 3
            },
            {
              label: 'UPDATE',
              value: 4
            },
            {
              label: 'PUT',
              value: 5
            }
          ]
        },
        {
          prop: 'useScene',
          label: '使用场景',
          placeholder: '请输入使用场景',
          maxLength: 75
        }
      ]
    }
  },
  computed: {
    ...mapState('system', ['reflushApi'])
  },
  methods: {
    ...mapActions('system', ['ReflushApi']),
    // 表格操作按钮
    handleTableDelete (row, index) {
      this._confirmDelete().then(() => {
        this.fetchApisDelete([row.id])
      })
    },
    // 顶部操作按钮
    handleHeaderCreate () {
      this.$refs.addDialog.showDialog()
    },
    handleHeaderDelete () {
      if (this.list.selectedKeys.length) {
        this._confirmDelete().then(() => {
          this.fetchApisDelete(this.list.selectedKeys)
        })
      } else {
        this._messageOne()
      }
    },
    handleConfirmAdd (data, btn) {
      this.addFormLoading = true
      this.$request.fetchApisCreate(data).then(res => {
        if (res.code === 200) {
          this._messageSuccess('save')
          this.fetchTableApi()
        }
        this.addFormLoading = false
      }).catch(() => {
        this.addFormLoading = false
      })
    },
    // 发送请求事件
    fetchApisDelete (ids) {
      this.list.loading = true
      this.$request.fetchApisDelete(ids).then(res => {
        if (res.code === 200) {
          this._messageSuccess('delete')
          this.fetchTableApi()
        }
      }).then(this.hideTableLoading)
        .catch(this.hideTableLoading)
    },
    fetchTableCallBack (res) {
      if (res.code === 200) {
        this.list.data = res.data.content
        this.list.totalCount = res.data.totalElements
      }
    }
  },
  mounted () {
    this.fetchTableApi()
  },
  activated () {
    if (this.reflushApi) {
      this.fetchTableApi()
      this.ReflushApi(false)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
